import { RG_TYPE as a, isPolygonClosed as l } from "@project-rouge/rg-core";
import { getLevelBoundary as d } from "../../3d/boundary/index6.js";
import { getBoundaryOfObjects as f } from "../../3d/boundary/index4.js";
function g(t, o) {
  const r = t.children.filter((n) => n.type === a.Facade && n.data.levelId === o.uuid);
  let e = [];
  return r.length > 0 ? e = f(r) : e = d(t, o), e.length === 0 ? [] : (e = l(e) ? e : e.concat([e[0]]), e);
}
export {
  g as getLevelGEAPolygon
};
//# sourceMappingURL=index2.js.map
